import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccessService } from 'app/core/services/access.service';
import { ChargeService } from 'app/core/services/charge.service';
import { CommonService } from 'app/core/services/common.service';
import { EmployeePayrollService } from 'app/core/services/employee-payroll.service';
import { RefreshScalelineService } from 'app/core/services/refresh-scaleline/refresh-scaleline.service';
import { SalaryScaleService } from 'app/core/services/salary-scale.service';

@Component({
  selector: 'add-payroll-line-dialog',
  templateUrl: './add-payroll-line-dialog.component.html',
  styleUrls: ['./add-payroll-line-dialog.component.scss']
})
export class AddPayrollLineDialogComponent implements OnInit {
  isLoading: boolean = false;
  scaleForm: FormGroup;
  configData: any[] = [];
  charge: any[] = [];

  constructor(public dialogRef: MatDialogRef<AddPayrollLineDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private commonService: CommonService,
    private chargeService: ChargeService, private employeePayrollService: EmployeePayrollService,
    private refreshScaleLineService: RefreshScalelineService) {
    this.scaleForm = this.fb.group({
      id: [0],
      invoiceId: [this.data.invoiceId || 0],
      isEmployeeShare: [false],
      chargeId: [0],
      amount: ['0', [Validators.pattern(/^-?[0-9]+(\.[0-9]*)?$/)]],
      employeeShare: ['0', [Validators.pattern(/^-?[0-9]+(\.[0-9]*)?$/)]],
    });
  }

  ngOnInit(): void {
    this.getCharges();
    if (this.data?.selectedScale?.id > 0) {
      const selectedElement = this.data.selectedScale;
      console.log(selectedElement);
      this.scaleForm.patchValue({
        id: selectedElement.id || 0,
        invoiceId: this.data?.invoiceId || 0,
        isEmployeeShare: selectedElement.isEmployeeShare || false,
        chargeId: selectedElement.chargeID || 0,
        amount: selectedElement.amount || '0',
        employeeShare: selectedElement.employeeShare || '0',
      });
    }
    if (this.data?.invoiceId > 0) {
      this.scaleForm.patchValue({
        invoiceId: this.data?.invoiceId || 0,
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getCharges() {
    this.chargeService.getCharges().subscribe({
      next: res => {
        this.charge = res;
      }
    })
  }

  save() {
    this.isLoading = true;

    if (this.scaleForm.invalid) {
      Object.keys(this.scaleForm.controls).forEach((controlName) => {
        this.scaleForm.get(controlName)?.markAsTouched();
        this.isLoading = false;
      });
      return;
    }
    if (this.scaleForm.valid) {
      this.employeePayrollService.createUpdatePayrollLine(this.scaleForm.value).subscribe({
        next: res => {
          this.refreshScaleLineService.emitRefresh2(this.scaleForm.value.id);
          Promise.resolve().then(() => {
            this.isLoading = false;
            this.dialogRef.close();
          });
        },
        error: err => {
          console.log(err);
          this.isLoading = false;
        }
      })
    }
  }
}
